import { renderToString } from 'katex';

// تبدیل ارقام لاتین به فارسی (فقط برای نمایش بصری)
export const toPersianDigits = (str) =>
  String(str).replace(/[0-9]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[+d]);

/**
 * رندر LaTeX با KaTeX و فارسی‌سازی ارقامِ «متن قابل مشاهده».
 *
 * مهم: تبدیل فقط روی TEXT NODEها انجام می‌شود نه attribute ها — چون
 * اعداد داخل viewBox/path رادیکال‌ها (SVG) و مقادیر style (em) باید لاتین بمانند
 * وگرنه فرمول به هم می‌ریزد.
 *
 * - بخش katex-mathml (داده خام برای دیتابیس): دست‌نخورده با ارقام لاتین
 * - بخش katex-html (آنچه کاربر می‌بیند): اعداد فارسی ۰۱۲۳...
 */
const FA_DIGITS = '۰۱۲۳۴۵۶۷۸۹';

/**
 * جای‌نگهدارهای «#?» (که KaTeX آن‌ها را خطای parse می‌گیرد) به مربع خالیِ آبیِ
 * قابل‌مشاهده تبدیل می‌شود تا معلم بفهمد کدام قسمت‌های فرمول هنوز پر نشده‌اند.
 * LaTeX اصلی (با #?) در data-latex ذخیره می‌ماند و مودال ویرایش هم همان را نشان می‌دهد.
 */
export const prepareLatexForDisplay = (latex) =>
  String(latex || '').replace(/#\?/g, String.raw`{\color{2563eb}\square}`);

export const renderLatexToHtml = (latex, options = {}) => {
  if (!latex) return '';
  let html;
  try {
    html = renderToString(prepareLatexForDisplay(latex), { throwOnError: false, ...options });
  } catch {
    return latex;
  }

  // در محیط بدون DOM (SSR) خروجی خام برگردانده شود
  if (typeof document === 'undefined') return html;

  const container = document.createElement('div');
  container.innerHTML = html;

  const visual = container.querySelector('.katex-html');
  if (visual) {
    const walker = document.createTreeWalker(visual, NodeFilter.SHOW_TEXT);
    let textNode;
    while ((textNode = walker.nextNode())) {
      if (/[0-9]/.test(textNode.nodeValue)) {
        textNode.nodeValue = textNode.nodeValue.replace(/[0-9]/g, (d) => FA_DIGITS[+d]);
        // فونت وزیر برای ارقام فارسی (KaTeX گلیف لاتین دارد و وزیر را نمی‌شناسد)
        const span = textNode.parentElement;
        if (span && !span.classList.contains('fa-digit')) {
          span.classList.add('fa-digit');
        }
      }
    }
  }

  return container.innerHTML;
};
